import CommunityPathsHelper from './models/CommunityPathsHelper';
import CommunityPathsMapChannelsHelper from './models/CommunityPathsMapChannelsHelper';

export default {
  communityPaths: CommunityPathsHelper,
  mapChannels: CommunityPathsMapChannelsHelper,
};
